var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilterIcon = function SvgFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "currentColor",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.061 2.192a.846.846 0 1 0 0 1.693.846.846 0 0 0 0-1.693m2.539.846a2.538 2.538 0 0 1-4.937.835 1 1 0 0 1-.14.012H1.446a.846.846 0 1 1 0-1.693h5.077q.072 0 .14.012a2.54 2.54 0 0 1 4.937.834M3.138 7.833c-.467 0-.846.41-.846.917 0 .506.38.917.846.917.468 0 .847-.41.847-.917 0-.506-.38-.917-.847-.917m0 3.667c1.114 0 2.06-.777 2.402-1.857a1 1 0 0 0 .207.024h4.936a.917.917 0 1 0 0-1.834H5.747a1 1 0 0 0-.207.024C5.198 6.777 4.252 6 3.138 6 1.737 6 .6 7.231.6 8.75s1.137 2.75 2.538 2.75",
    clipRule: "evenodd"
  })));
};
export default SvgFilterIcon;